// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ps1u","content":"styles_content__1O0Xn"};